import { setLoginStatus, login } from "actions/user";
import classnames from "classnames";
import SageButton from "kit/SageButton";
import SageErrorAlert from "kit/SageErrorAlert";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import loginStatusSelector from "selectors/loginStatus";
import styles from "./Login.module.scss";

const LoginBody: React.FC = () => {
    const dispatch = useDispatch();
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const loginStatus = useSelector(loginStatusSelector);
    const isLoading = React.useMemo(() => loginStatus === "loading", [
        loginStatus,
    ]);
    const errorText = React.useMemo(() => {
        if (loginStatus === "unauthorized") {
            return "Either the account does not exists or the password is invalid.";
        } else if (loginStatus === "error") {
            return "An unknown error occurred when trying to log you in";
        }
        return null;
    }, [loginStatus]);
    const onDismissError = React.useCallback(() => {
        dispatch(setLoginStatus("none"));
    }, [dispatch]);
    const loginFormSubmitted = React.useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            dispatch(login(email, password));
        },
        [dispatch, email, password]
    );
    const onEmailChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setEmail(e.target.value);
        },
        [setEmail]
    );
    const onPasswordChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setPassword(e.target.value);
        },
        [setPassword]
    );

    return (
        <>
            <form onSubmit={loginFormSubmitted} id="login-form">
                <div className="form-group">
                    <label htmlFor="emailInput">Email Address</label>
                    <input
                        value={email}
                        onChange={onEmailChange}
                        disabled={isLoading}
                        type="email"
                        className="form-control"
                        id="emailInput"
                        aria-describedby="emailHelp"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="passwordInput">Password</label>
                    <input
                        value={password}
                        onChange={onPasswordChange}
                        disabled={isLoading}
                        type="password"
                        className="form-control"
                        id="passwordInput"
                    />
                </div>
                <SageButton loading={isLoading} text="Login" type="submit" />
            </form>
            {loginStatus === "unauthorized" && (
                <div className={styles.linkContainer}>
                    <Link
                        className={classnames(styles.link, "text-danger")}
                        to="/welcome/send-reset-password"
                    >
                        Forgot your password? Recover it here
                    </Link>
                </div>
            )}
            {errorText && (
                <SageErrorAlert onDismiss={onDismissError} text={errorText} />
            )}
        </>
    );
};

export default LoginBody;
